import { navItems } from '@/data/site'

export function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="site-footer">
      <div className="container-wide footer-main">
        <div>
          <p className="eyebrow !text-apricot before:!bg-apricot">The Noa Movement</p>
          <p className="footer-statement">Que ninguna familia camine sola.</p>
        </div>

        <div className="footer-column">
          <h2>Explora</h2>
          <ul className="footer-links">
            {navItems.map((item) => (
              <li key={item.href}>
                <a href={item.href}>{item.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-column">
          <h2>Más</h2>
          <ul className="footer-links">
            <li>
              <a href="/ruta-critica/">Ruta crítica</a>
            </li>
            <li>
              <a href="/los-tios-chidos/">Los Tíos Chidos</a>
            </li>
            <li>
              <a href="https://thenoamovement.com/aviso-de-privacidad/">
                Aviso de privacidad
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-wide footer-bottom">
        <span>© {year} The Noa Movement</span>
        <span>Hecho con esperanza, cuidado y comunidad.</span>
      </div>
    </footer>
  )
}
